var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_327)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 5C11.4468 5 10.9999 4.55313 10.9999 4C10.9999 3.44687 11.4468 3 11.9999 3H16.9999C17.553 3 17.9999 3.44687 17.9999 4V9C17.9999 9.55312 17.553 10 16.9999 10C16.4468 10 15.9999 9.55312 15.9999 9V6.41563L10.7062 11.7063C10.3155 12.0969 9.68115 12.0969 9.29053 11.7063L5.9999 8.41562L1.70615 12.7063C1.31553 13.0969 0.681152 13.0969 0.290527 12.7063C-0.100098 12.3156 -0.100098 11.6812 0.290527 11.2906L5.29053 6.29063C5.68115 5.9 6.31553 5.9 6.70615 6.29063L9.9999 9.58438L14.5843 5H11.9999Z",
    fill: "#10B981"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8_327"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.19def806066c385f25e273ec32a82155.svg";
export { ForwardRef as ReactComponent };